<template>
	<section class="main-content contentblocks">
		<div class="row row-header align-center white"></div>
		<content-block v-for="(room, index) in items" :key="index" :index="index" :item="room" variant="room" />
	</section>
</template>

<script setup>
defineProps({
	items: { type: Array, default: () => [] },
});
</script>

<style lang="scss" scoped>
.contentblock {
	margin: 40px auto;
	position: relative;
}

.contentblock-image {
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	width: 58%;
	z-index: 1;
}

.contentblock-content {
	background: rgb(249 246 242 / 80%);
	box-shadow: 0 18px 18px rgb(0 0 0 / 25%);
	backdrop-filter: blur(34px);
	padding: 60px 90px;
	margin: 60px auto;
	position: relative;
	z-index: 2;

	h2 {
		padding-bottom: 20px;
		border-bottom: 1px solid black;
	}
}

.even {
	.contentblock-image {
		left: 0;
		right: auto;
	}

	.contentblock-content {
		float: right;
	}
}

.contentblock-image img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

@media (max-width: 920px) {
	.contentblock-image {
		width: 100%;
		position: relative;
		inset: auto;
	}

	.contentblock {
		display: flex;
		flex-flow: wrap column-reverse;
	}

	.contentblock-content {
		margin: 0 auto 50px;
		padding: 50px 30px;
	}
}
</style>
